import React from "react";
import Rank from "./components/Rank";

export default function index() {
  return <Rank />;
}
